import { render, staticRenderFns } from "./labor_business.vue?vue&type=template&id=048f95ab&scoped=true"
import script from "./labor_business.vue?vue&type=script&lang=js"
export * from "./labor_business.vue?vue&type=script&lang=js"
import style0 from "./labor_business.vue?vue&type=style&index=0&id=048f95ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f95ab",
  null
  
)

export default component.exports